import { Link } from 'react-router'
import { ArrowRight, Rocket, Telescope } from 'lucide-react'
import type { CompanyStatus } from '@takeit4me/shared'
import { useMe } from '../../auth'
import type { Tone } from '../../lib/labels'

export const LIFECYCLE: Record<CompanyStatus, { label: string; tone: Tone; help: string }> = {
  onboarding: { label: 'Setting up', tone: 'gray', help: 'Nothing is sent to customers yet.' },
  shadow: { label: 'Shadow mode', tone: 'blue', help: 'The AI drafts every reply for you to compare; nothing is sent by the AI.' },
  active: { label: 'Live', tone: 'green', help: 'The AI answers customers within the autonomy each request type has earned.' },
  suspended: { label: 'Suspended', tone: 'red', help: 'Sending, the AI and tasks are paused. Messages are still received and kept.' },
}

/** A slim bar in the shell for admins until the company is live (OP-07). */
export function OnboardingBanner() {
  const me = useMe()
  const status = me.lifecycle?.status
  if (me.staff.role !== 'admin' || (status !== 'onboarding' && status !== 'shadow')) return null
  return (
    <div className="shrink-0 bg-indigo-50 border-b border-indigo-100 text-indigo-900 px-5 max-md:px-4 py-1.5 text-[12px] flex items-center gap-2">
      {status === 'onboarding' ? <Rocket size={14} /> : <Telescope size={14} />}
      <span className="flex-1 min-w-0 truncate">{status === 'onboarding' ? 'Finish setting up, then run in shadow mode before going live.' : 'Shadow mode: the AI drafts, your team sends. Go live when the checklist is done.'}</span>
      <Link to="/onboarding" className="font-semibold whitespace-nowrap">Getting started <ArrowRight size={12} className="inline" /></Link>
    </div>
  )
}
